module.exports = __webpack_public_path__ + "img/48CH_Vin.8995b1f1.png";